<template>
<div>
    {{header}}<br>
   <select class="form-control" id="id_Employee" name="Employee" style="overflow:scroll;" v-model="employeeSelected" @change="addUser">
                        <option  selected value="-2"> -- None -- </option>
                        <option  disabled value="-1"> -- Select to add more -- </option>
                        <option v-for="emp in EmployeeList"  v-bind:key="emp.idEmployee" :value="emp.idEmployee" >{{emp.employee}} </option>
					
    </select><br>
    <div v-for="emp in employeeTagged"  v-bind:key="emp.idEmployee" :value="emp.idEmployee" ><b-row><b-col class="text-center">{{emp.employee}}</b-col><b-col class="text-center"><b-button variant="outline-primary" @click="removeUser(emp.idEmployee,emp.employee)">X</b-button></b-col></b-row></div>
     <br>
</div>
</template>

<script>

import axios from 'axios';
//import moment from 'moment';

export default {
  props: ['header',"employeeTagged"],
  components: {
   
  },
  data() {
    return {
      EmployeeList: [],
      employeeSelected : -2,
    
      ticketags: []
    }
  }
  ,
   created: function () {
     
     var mainObject = this;
     //console.log(mainObject);
     axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
          params: {
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
            // console.log("ListEmployees");
           // console.log(response);
          let ListidEmployeeRemove = [ 29,21]; // remove users Auto Generated, test user
          for( let i = 0 ;i < response.data.users.length ; i++ )
          {
              let found = false;
              for( let j = 0 ; j < ListidEmployeeRemove.length ; j++ )
              {
                  if ( ListidEmployeeRemove[j] == response.data.users[i].idEmployee )
                  {
                      found = true;
                      break;
                  }
              }
              if ( !found)  mainObject.EmployeeList.push(response.data.users[i]);


          }
          //mainObject.EmployeeList = response.data.users;
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
           
          // always executed
          //console.log("Made request axios to get getTicketTags");
        });

   }
   , methods :  {
     addUser : function ()
      {
        var mainObject = this;
        //console.log("Called add user for : "+mainObject.employeeSelected);
        if ( mainObject.employeeSelected > 0 )
        {
            let alreadyAdded = false;
             for( let i = 0 ; i < mainObject.employeeTagged.length ; i++ )
             {
                if (mainObject.employeeSelected == mainObject.employeeTagged[i].idEmployee )
                {
                    alreadyAdded = true;
                    break;

                }

             }
            if ( !alreadyAdded )
            {    
                for( let i = 0 ; i < mainObject.EmployeeList.length ; i++ )
                {
                    if (mainObject.employeeSelected == mainObject.EmployeeList[i].idEmployee )
                    {
                        mainObject.employeeTagged.push( mainObject.EmployeeList[i]);
                        mainObject.employeeSelected = -1;
                        break;
                    }
                }
            }
        }
        if ( mainObject.employeeSelected == -2 )
        {
            mainObject.employeeTagged = [];
        }
        mainObject.$emit('updateEmployeeTagged', mainObject.employeeTagged)
        
        //console.log(mainObject);
      },
    removeUser : function(idEmployee, Employee)
    {
        console.log("Called rmove user :"+idEmployee);
        let mainObject = this;
        mainObject.$swal({
            title: "",
            text: 'Are you sure you want to unsubscibe '+Employee+ ' from this Ticket',
            type: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText:  'Cancel'
            }).then((result) => {
            if (result.value) 
            {
                
               for( let i = 0 ; i < mainObject.employeeTagged.length ; i++ )
             {
                if (idEmployee == mainObject.employeeTagged[i].idEmployee )
                {
                    mainObject.employeeTagged.splice(i,1);
                    if ( mainObject.employeeTagged.length == 0 )
                    {
                        mainObject.employeeSelected = -2;
                    }
                    break;

                }

             }
         mainObject.$emit('updateEmployeeTagged', mainObject.employeeTagged )
               

            }
            else
            {
                   
                console.log("Do nothing");
            }
        });
         

    }
   }
}
</script>

